import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "odoo_bi_token";
const USER_KEY = "odoo_bi_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getStoredUser = () => {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
};
export const setStoredUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default client;

// ---- API calls ----
export const apiLogin = (login, password) =>
  client.post("/auth/login", { login, password }).then((r) => r.data);

export const apiMe = () => client.get("/auth/me").then((r) => r.data);

export const apiClearCache = () => client.post("/cache/clear").then((r) => r.data);

export const apiDashboard = (module, params) =>
  client.get(`/${module}`, { params }).then((r) => r.data);
